import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './index.css';

const hostname = window.location.hostname.toLowerCase();
const pathname = window.location.pathname;

const isCaptureHost =
  hostname === 'capture.everyid.com';

const isCapturePath =
  /^\/lp(?:\/|$)/i.test(pathname);

// The capture host—or any legacy /lp link—loads only CaptureApp.
// Every other URL loads the full administrative application.
const RootApp = isCaptureHost || isCapturePath
  ? lazy(() =>
      import(
        /* webpackChunkName: "capture-app" */
        './CaptureApp'
      )
    )
  : lazy(() =>
      import(
        /* webpackChunkName: "admin-app" */
        './App'
      )
    );

const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <BrowserRouter>
    <Suspense
      fallback={
        <div
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#f4f4f4',
            color: '#333',
            fontFamily: 'Arial, sans-serif'
          }}
        >
          Loading…
        </div>
      }
    >
      <RootApp />
    </Suspense>
  </BrowserRouter>
);
